// extracted by mini-css-extract-plugin
export default {"label":"label---da_vc"};